module.exports = __webpack_public_path__ + "img/SES_40_38_072_780.6e112fda.jpg";